/**
 * For more information about GDPR password compliance, see:
 * https://www.bsi.bund.de/EN/Themen/Verbraucherinnen-und-Verbraucher/Informationen-und-Empfehlungen/Cyber-Sicherheitsempfehlungen/Accountschutz/Sichere-Passwoerter-erstellen/sichere-passwoerter-erstellen_node.html
 */

export const GDPR_PASSWORD_MINIMUM_LENGTH = 8
export const GDPR_PASSWORD_SAFE_MINIMUM_LENGTH = 12

const REGEX_LOWER_CASE = /[a-z]/
const REGEX_UPPER_CASE = /[A-Z]/
const REGEX_DIGIT = /\d/
const REGEX_SPECIAL_CHARACTER = /[\W_]/

export const isPasswordGdprCompliant = password => {
  const hasLowerCase = REGEX_LOWER_CASE.test(password)
  const hasUpperCase = REGEX_UPPER_CASE.test(password)
  const hasDigit = REGEX_DIGIT.test(password)
  const hasSpecialCharacter = REGEX_SPECIAL_CHARACTER.test(password)
  const hasMinimumLength = password.length >= GDPR_PASSWORD_MINIMUM_LENGTH

  return (
    hasLowerCase &&
    hasUpperCase &&
    hasDigit &&
    hasSpecialCharacter &&
    hasMinimumLength
  )
}

export const composeGdprPasswordValidatorMessage = (password, translations) => {
  if (!password) {
    return ''
  }

  let message = ''

  const remainingLength = GDPR_PASSWORD_MINIMUM_LENGTH - password.length
  const remainingUppercase = Math.max(
    1 - (password.match(REGEX_UPPER_CASE) || []).length,
    0
  )
  const remainingLowercase = Math.max(
    1 - (password.match(REGEX_LOWER_CASE) || []).length,
    0
  )
  const remainingDigit = Math.max(
    1 - (password.match(REGEX_DIGIT) || []).length,
    0
  )
  const remainingSpecialChar = Math.max(
    1 - (password.match(REGEX_SPECIAL_CHARACTER) || []).length,
    0
  )

  if (remainingLength > 0) {
    message += `${remainingLength} ${translations.character}, `
  }
  if (remainingUppercase > 0) {
    message += `${remainingUppercase} ${translations.uppercase}, `
  }
  if (remainingLowercase > 0) {
    message += `${remainingLowercase} ${translations.lowercase}, `
  }
  if (remainingDigit > 0) {
    message += `${remainingDigit} ${translations.digit}, `
  }
  if (remainingSpecialChar > 0) {
    message += `${remainingSpecialChar} ${translations.specialCharacter}, `
  }

  if (message) {
    message = `${translations.use}` + message
    message = message.slice(0, -2) + '.'
  }

  return message
}

export const getGdprPasswordValidationMessage = (password, i18n) => {
  const translations = {
    use: i18n._('passwordValidation.stillUse'),
    character: i18n._('passwordValidation.character'),
    uppercase: i18n._('passwordValidation.majuscule'),
    lowercase: i18n._('passwordValidation.miniscule'),
    digit: i18n._('passwordValidation.number'),
    specialCharacter: i18n._('passwordValidation.special'),
  }

  const validationMessage = composeGdprPasswordValidatorMessage(
    password,
    translations
  )

  return validationMessage
}
